import { render } from "./AkadTerms.vue?vue&type=template&id=10ee530c&scoped=true"
import script from "./AkadTerms.vue?vue&type=script&lang=js"
export * from "./AkadTerms.vue?vue&type=script&lang=js"

import "./AkadTerms.vue?vue&type=style&index=0&id=10ee530c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ee530c"]])

export default __exports__